<template>
  <div name="item-desc" class="col-xs-10 col-md-11 box-label" :class="{ 'border-color-skin' : choiceDisp}" @click="toggleChoiceDisp()">
    <div class="main-label" :class="{ 'active color-skin' : choiceDisp}"><label :class="classSubject">{{mainDesc}}</label></div>
    <div class="more-label" v-show="choiceDisp">{{defineDesc}}</div>
  </div>
</template>

<script>
export default {
  name: 'item-desc',
  data () {
    return {
      choiceDisp: false
    }
  },
  props: [ 'mainDesc', 'defineDesc', 'classSubject' ],
  methods: {
    toggleChoiceDisp () {
      this.choiceDisp = !this.choiceDisp
    }
  }
}
</script>



// WEBPACK FOOTER //
// itemDesc1.vue?53edeaef